
import React, { Component, Fragment } from 'react';
// import UploadFile from './uploadFile';
import Modal from "react-bootstrap/Modal";
import { convertDate } from '../../../utils/miscelleneous';
import { BallBeat } from '../../../Loader/loader';
import '../mentors.scss';
import Select from 'react-select';
import { Editor } from './Editor';
import Snackbar from '@mui/material/Snackbar';

export default class QueryDetail extends Component {
    state = {
        isAddLink: false,
        reply: '',
        isConfirm: false,
        type: '',
        mentor: null
    }

    addLink = () => {
        this.setState({
            isAddLink: true,
        })
    }

    handleModal = () => {
        this.setState({
            isAddLink: false
        })
    }

    changeMentors = (e) => {
        this.setState({
            mentor: e,
            mentor_id: e.value,
            mentorErr: ''
        })
    }

    changeReply = (val) => {
        this.setState({
            reply: val
        })
    }

    sendReply = async () => {
        this.setState({
            isLoading: true
        })
        console.log(this.state.reply)
        if ((window.location.origin === 'https://edsanta.elitelearning.io' && localStorage.getItem('role')?.includes('admin'))) {
            if (this.state.mentor === null) {
                this.setState({
                    mentorErr: 'select mentor',
                    isLoading: false
                })
            }
            else if (this.state.reply.trim('') === '' || null) {
                this.setState({
                    isLoading: false
                })
            }
            else {
                let obj = {
                    _id: this.props.question._id,
                    reply: this.state.reply,
                    mentor_id: this.state.mentor_id,
                    attachments: []
                }
                await this.props.replySentFromAdmin(obj)
                this.setState({
                    reply: '',
                    disable: true,
                    mentor: null,
                    isLoading: false
                })
            }
        } else {
            if (this.state.reply.trim('') === '' || null) {
                this.setState({
                    isLoading: false
                })
            }
            else {
                let obj = {
                    _id: this.props.question._id,
                    reply: this.state.reply,
                    attachments: []
                }
                await this.props.replySent(obj);
                this.setState({
                    reply: '',
                    disable: true,
                    isLoading: false
                })
            }
        }
    }

    uploadFile = async (obj) => {
        await this.props.uploadFile(obj)
        this.setState({
            isAddLink: false
        })
    }
    openConfirm = (id, type) => {
        this.setState({
            isConfirm: true,
            type
        })
    }

    handleClose = () => {
        this.setState({
            isConfirm: false
        })
    }

    markClosed = async () => {
        if (this.state.type === 'junk') {
            await this.props.markasjunk(this.props.question?._id)
        } else {
            await this.props.markasclosed(this.props.question?._id)
        }
        this.setState({
            isConfirm: false,
            type: ''
        })
    }
    render() {

        const { question, replies, selectMentors, theme, successEnable, successMessage, successMessageText, t } = this.props
        return (
            <div className='query-details-form'>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successMessage}
                    onClose={() => this.props.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successEnable}
                    onClose={() => this.props.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />

                <div className='query-header' style={{ width: (question.junk || question.closed) ? '' : localStorage.getItem('role')?.includes('admin') ? '' : '55%' }}>
                    <img src='/images/back1.svg' onClick={this.props.closeDetails} className='cursor-pointer' alt='' />
                    <p>{t('Query Details')}</p>
                    {question?.junk ?
                        <div style={{ color: '#00B24B' }} className='mark-as'>{t('JUNK')}</div>
                        :
                        question?.closed ?
                            <div style={{ color: '#00B24B' }} className='mark-as'>{t('CLOSED')}</div>
                            :
                            (localStorage.getItem('role')?.includes('admin') && <div className='d-flex'>
                                <div className='mark-as' style={{ color: '#9d99bf' }} onClick={() => this.openConfirm(this.props.question._id, 'close')}> <img src='/images/mark-as-icon.svg' style={{ verticalAlign: 'middle' }} alt='' />  MARK AS CLOSED</div>&nbsp;&nbsp;
                                <div className='mark-as' style={{ color: '#9d99bf' }} onClick={() => this.openConfirm(this.props.question._id, 'junk')}> <img src='/images/mark-as-icon.svg' style={{ verticalAlign: 'middle' }} alt='' />  MARK AS JUNK</div>
                            </div>)}
                </div>
                <div className='query-details'>
                    {question !== undefined &&
                        <div className='row'>
                            <div className='col-md-3 mb-3'>
                                <h3>{t("Question Catagory")}</h3>
                                <p>{question?.category}</p>
                            </div>
                            <div className='col-md-3  mb-3'>
                                <h3>{t('From')}</h3>
                                <p>{question?.name}</p>
                            </div>

                            <div className='col-md-2  mb-3'>
                                <h3>{t('Skill')}</h3>
                                <p>{question?.skill?.title}</p>
                            </div>
                            <div className='col-md-2'>
                                <h3>{t('Question Date')}</h3>
                                <p>{convertDate(question?.createdAt)}</p>
                            </div>
                        </div>
                    }
                    <div className='conversations-details'>
                        <h3>{t('Question Title')}
                            {/* {question?.attachments?.length ? <p className='float-right cursor-pointer d-flex align-items-center' onClick={() => window.open(question.attachments.map(el => el), '_blank')}><img src='/images/attachment.png' alt='' /> &nbsp;<h3>View attachment</h3> </p> : null} */}
                        </h3>
                        <p>{convertDate(question?.createdAt)}</p>
                        <hr />
                        <h4>
                            {question?.question}
                        </h4>
                        {
                            replies !== undefined && replies?.map(el => {
                                return (
                                    <div className='faculty-response'>
                                        <div className='d-flex justify-content-between'>
                                            <div className='d-flex'>
                                                {
                                                    el.profile_image !== null ?
                                                        <div className='intial'><img src={el.profile_image} alt='' width='40px' height='40px' className='rounded-circle' /></div>
                                                        :
                                                        <div className='intial' style={{ background: '#8b7df2' }}>{el.initial}</div>

                                                }
                                                &nbsp;&nbsp;
                                                <h3 className='text-capitalize'>{el.name}<br />
                                                    <p>{convertDate(el.createdAt)}</p>
                                                </h3>
                                            </div>
                                            {(localStorage.getItem('role')?.includes('admin') || localStorage.getItem('role')?.includes('mentor')) && localStorage.getItem('id') === el.from ?
                                                <p className='float-right cursor-pointer d-flex align-items-center' onClick={() => this.props.deleteReply(question._id, el._id)}><img src='/images/delete.svg' alt='' /></p>
                                                : null
                                            }
                                        </div>
                                        <h4 className='mt-1' dangerouslySetInnerHTML={{ __html: el.text }} />
                                    </div>
                                )
                            })
                        }
                    </div>
                    {
                        (question.closed || question?.junk) ? null
                            :
                            <Fragment>
                                <div className='reply-btn'>
                                    {
                                        (window.location.origin === 'https://edsanta.elitelearning.io' && localStorage.getItem('role')?.includes('admin')) &&
                                        <Fragment>
                                            <div style={{ width: '30%' }}>
                                                <h3>{t('Mentors')}</h3>
                                                <Select
                                                    className="mt-2"
                                                    classNamePrefix="select"
                                                    defaultValue=''
                                                    placeholder=''
                                                    isSearchable={true}
                                                    value={this.state.mentor}
                                                    name="jobtitle"
                                                    onChange={(e) => this.changeMentors(e)}
                                                    options={selectMentors?.map(el => [{ value: el._id, label: `${el.firstName} ${el.lastName}`, image: el.image, initial: el.initial }][0])}
                                                    formatOptionLabel={el => (
                                                        <div className="faculty-option d-flex align-items-center">
                                                            {
                                                                el.image !== null ?
                                                                    <img src={el.image} alt="faculty" width='20px' height='20px' className='rounded-circle' />
                                                                    : <div className='intial' style={{ background: '#8b7df2' }}>{el.initial}
                                                                    </div>
                                                            }
                                                            &nbsp;&nbsp;<span>{el.label}</span>
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                        </Fragment>
                                    }

                                    <span style={{ color: 'red' }}>{this.state.mentorErr}</span>
                                    <h3 className='mt-2'>{t('Reply')}
                                        {/* <div className='float-right cursor-pointer d-flex align-items-center' onClick={() => this.addLink()}> <img src='/images/attachment.png' alt='' />&nbsp; <h3>Attach a file</h3></div> */}
                                    </h3>
                                    <div className='mt-2'>
                                        <Editor content={this.state.reply} setTitle={this.changeReply} />
                                    </div>
                                    {/* <textarea
                                        className='form-control mt-2'
                                        rows='4'
                                        cols='4'
                                        onChange={(e) => this.changeReply(e.target.value)}
                                        value={this.state.reply}
                                    /> */}

                                    {/* <ul className="resource-holder mt-3">
                                        {
                                            this.props.attachment !== undefined && this.props.attachment.map((el, index) => {
                                                var Extension = el
                                                    .substring(el.lastIndexOf(".") + 1)
                                                    .toLowerCase();
                                                return (
                                                    <li className="resource border-bottom" >
                                                        <div className="col-md-1 col-1 pl-0 resource-image" >
                                                            <img src={Extension === 'pdf' ? '/images/file.png' : (Extension === 'png' || Extension === 'jpg' || Extension === 'jpeg') ? '/images/png-placeholder.png' : '/images/default.png'} alt='' />
                                                        </div>
                                                        <div className="col-md-9 col-9 recent-title">
                                                            <div>
                                                                <p className='d-flex justify-content-start align-items-center mt-1 elipsis'>
                                                                    {el}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-1 col-1 d-flex justify-content-end align-items-center cursor-pointer" style={{ marginLeft: window.innerWidth > 767 ? '' : 40 }} onClick={() => window.open(el, '_blank')}>
                                                            <img src='/images/view_grey.svg' alt='' />
                                                        </div>
                                                    </li>
                                                )
                                            })

                                        }
                                    </ul> */}
                                    <button className='re-btn' style={{ backgroundColor: theme?.bgColor }} disabled={this.state.isLoading ? true : false} onClick={this.sendReply}>{this.state.isLoading ? <BallBeat color='#fff' /> : t('Reply')}</button>
                                </div>
                            </Fragment>

                    }

                </div>
                {/* confirmation modal */}
                <Modal show={this.state.isConfirm} centered aria-labelledby="contained-modal-title-vcenter" dialogClassName={"confirm-modal"}>
                    <Modal.Body style={{ padding: 15 }}>
                        <div className='text-center' >
                            {this.state.type === 'junk' ? <h1 style={{ fontSize: 18 }}>Are you sure you want to mark as junk ?</h1> : <h1 style={{ fontSize: 18 }}>Are you sure you want to close this query? You cannot reopen it.</h1>}
                            <div className="save-btn">
                                <button style={{ backgroundColor: theme?.bgColor }} className="del-btn" onClick={this.markClosed} >Confirm</button>
                                <button className="del-btn" onClick={this.handleClose}>Cancel</button>
                            </div>

                        </div>
                    </Modal.Body>
                </Modal>

            </div >
        )
    }
}